<template>
  <div></div>
  <!-- Renderless guard: enforces punchout-session cleanup on every page. No UI. -->
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import {
  LOCAL_STORAGE_CREDENTIALS_SET_FOR_PUNCHOUT_SESSION,
  punchoutCookies,
} from "@/core/utilities/punchout/punchoutCookies";

const route = useRoute();

onMounted(() => {
  // Do not interfere with an incoming punchout handshake (handled in home.vue), which arrives at / with a ?token= param.
  const token = route.query.token;
  if (route.path === "/" && token) {
    return;
  }

  // Check if we need to remove the current access_token if it was set for punchout authentication but no longer in a punchoutSession
  const credentialsSetForPunchoutSession = localStorage.getItem(LOCAL_STORAGE_CREDENTIALS_SET_FOR_PUNCHOUT_SESSION);
  if (credentialsSetForPunchoutSession && !punchoutCookies.value) {
    localStorage.removeItem(LOCAL_STORAGE_CREDENTIALS_SET_FOR_PUNCHOUT_SESSION);
    // Remove currency from both storages so the post-reload init in useCurrency.ts can properly initialize the currency
    // without any contamination from the old punchout session. For more details see -> TL-3423.
    localStorage.removeItem("currency");
    sessionStorage.removeItem("currency");
    // Refresh app state so useCurrency re-seeds the currency cleanly
    location.reload();
  }
});
</script>
